<template>
  <div class="Index">
    <closeZone></closeZone>
    <div class="theme"></div>
    <div class="title"></div>
    <div class="subtitle"></div>
    <div class="illustration"></div>
    <div class="goClassification" @click.stop.prevent="goClassification">
      立即体验
    </div>
    <div class="bottomMask"></div>
    <!-- <div class="deerAnimee"></div> -->
  </div>
</template>

<script>
// 引入wxjs
export default {
  name: 'index',
  data () {
    return {
      isVip: false
    }
  },
  created () {
    // this.getShareInfo();
  },

  mounted () {
    this.onLoadStatus()
  },
  beforeDestroy () {},

  methods: {
    onLoadStatus () {
      // if (window.__wxjs_environment !== 'miniprogram') {
      //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=888'
      // }
      const urlParams = new URLSearchParams(window.location.search)
      const isVip = urlParams.get('isVip')
      if (urlParams.get('isVip') === '1') {
        this.$store.commit('setIsVip', true)
      } else if (urlParams.get('isVip') === '0') {
        this.$store.commit('setIsVip', false)
      }
      const unionId = urlParams.get('unionId')
      this.$store.commit('setUnionId', unionId)
    },

    async goClassification () {
      this.$router.push({
        path: '/classification'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/indexImg/indexImg_bg.png) no-repeat center;
  background-size: 100% 100%;
  border-radius: 0px;
}

.theme {
  position: absolute;
  top: 115px;
  left: 50%;
  transform: translate(-50%);
  width: 450px;
  height: 42px;
  background: url(@/assets/indexImg/indexImg_theme.png) no-repeat center;
  background-size: 100% 100%;
}
.title {
  position: absolute;
  top: 175px;
  left: 50%;
  transform: translate(-50%);
  width: 693px;
  height: 171px;
  background: url(@/assets/indexImg/indexImg_title.png) no-repeat center;
  background-size: 100% 100%;
}
.subtitle {
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translate(-50%);
  width: 275px;
  height: 44px;
  background: url(@/assets/indexImg/indexImg_subtitle.png) no-repeat center;
  background-size: 100% 100%;
}
.illustration {
  position: absolute;
  top: 360px;
  // left: 50%;
  // transform: translate(-50%);
  width: 735px;
  height: 620px;
  background: url(@/assets/indexImg/indexImg_illustration.png) no-repeat center;
  background-size: 100% 100%;
}
.goClassification {
  cursor: pointer;
  width: 400px;
  height: 109px;
  position: absolute;
  z-index: 2;
  top: 1075px;
  left: 50%;
  transform: translate(-50%);
  background: url(@/assets/indexImg/indexImg_button.png) no-repeat center;
  background-size: 100% 100%;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 46px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.bottomMask {
  width: 330px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  top: 1155px;
  left: 50%;
  transform: translate(-50%);
  filter: blur(40px);
  background: rgba(52, 115, 252, 0.7);
}
</style>
